if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form) {
        document.addEventListener('DOMContentLoaded', () => {
          this.form.querySelector('[name=id]').disabled = false
        })
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      } else {
        console.warn('Form with ID #product-form not found.')
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      // Preserve the original form payload, then attach the selected frame to its cart line.
      const addonFieldset = document.querySelector(
        `.addon-product[data-section-id="${CSS.escape(this.dataset.source)}"]`
      );
      const addonVariantId = addonFieldset && addonFieldset.dataset.selectedAddonVariant
        ? Number(addonFieldset.dataset.selectedAddonVariant)
        : null;
      let cartAddRequest;

      if (addonVariantId) {
        formData.set('properties[_cb_frame_group]', crypto.randomUUID());
        formData.set('properties[_cb_frame_variant]', String(addonVariantId));
        config.body = formData;
        cartAddRequest = this.addWithFrame(config, formData, addonVariantId);
      } else {
        config.body = formData;
      }

      (cartAddRequest || fetch(`${routes.cart_add_url}`, config).then((response) => response.json()))
        .then((response) => {
          if (response.status) {

            // dispatch cart:error
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                },
              })
            );

            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // dispatch variant:add when fetch fail
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source,
              },
            })
          );

          fetch(`${routes.cart_url}.js`)
            .then((response) => {
              return response.text()
            })
            .then((state) => {
              const parsedState = JSON.parse(state)

              // dispatch cart:change for the entire basket
              document.dispatchEvent(
                new CustomEvent('cart:change', {
                  detail: {
                    cart: parsedState,
                    sectionId: this.dataset.source,
                  },
                })
              )
            })
            .catch((error) => {
              console.error('Error fetching cart state:', error);
            })

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          this.handleErrorMessage(e.message || window.cartStrings.error);
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form-recovery'});
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    async addWithFrame(config, formData, frameId) {
      const parentResponse = await fetch(routes.cart_add_url, config);
      const parent = await parentResponse.json();
      if (!parentResponse.ok || parent.status) return parent;
      if (!parent.key) throw new Error(window.cartStrings.error);
      try {
        const body = {
          items: [{id: frameId, quantity: Number(formData.get('quantity') || 1), parent_line_key: parent.key}],
          sections: formData.get('sections'),
          sections_url: window.location.pathname
        };
        const response = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify(body)
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || window.cartStrings.error);
        }
        return result;
      } catch (error) {
        const rollback = await fetch(routes.cart_change_url, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({id: parent.key, quantity: 0})
        });
        if (!rollback.ok) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'frame-recovery'});
        throw error;
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

